import React, { PropsWithChildren } from 'react';
import { AxiosResponse } from 'axios';
import { useForm } from '../../useForm';
import { Form } from '../../Form';
import { CustomErrorTypeMessages, DefaultStatusMessages } from '../../partials/StatusMessages';
import { useModalContext } from '../../../../components/organisms/ModalDialog/ModalContext';
import { AnyParameter, SonForm } from '../../types/SonForm';
import { isNotNullOrUndefined } from '../../../../lib/typeGuards';
import { AcceptDeclineFormTemplate } from './partials/AcceptDeclineFormTemplate';

export type AcceptDeclineForm = DefaultStatusMessages &
  CustomErrorTypeMessages &
  Omit<AcceptDeclineFormTemplate, 'onDecline' | 'fetchState'> & {
    form: SonForm<AnyParameter>;
    id?: string;
    onSuccess?: (response: AxiosResponse) => void;
    onDecline?: () => void;
  };

function filterOutEmptyValues(param: AnyParameter): boolean {
  if (Array.isArray(param.value) && param.value.length === 0) {
    return false;
  }
  return isNotNullOrUndefined(param.value) && param.value !== '';
}

export function AcceptDeclineForm({
  headline,
  form,
  id,
  onSuccess,
  onDecline,
  messageSuccess,
  messageForward,
  messageSending,
  messageFail,
  customErrorTypeMessages,
  hierarchy = 3,
  children,
}: PropsWithChildren<AcceptDeclineForm>) {
  const { formProps, fetchState, params } = useForm({ form, onSuccess });
  const { closeModal } = useModalContext(); // default behaviour as this form is mainly used in modals

  const hiddenParams = params.getAllByType('hidden');

  return (
    <Form {...formProps} id={id}>
      {hiddenParams.filter(filterOutEmptyValues).map(param => (
        <input type="hidden" key={param.value as string} name={param.name} value={param.value as string} />
      ))}
      {children}
      <AcceptDeclineFormTemplate
        messageSuccess={messageSuccess}
        messageSending={messageSending}
        messageFail={messageFail}
        messageForward={messageForward}
        headline={headline}
        fetchState={fetchState}
        hierarchy={hierarchy}
        customErrorTypeMessages={customErrorTypeMessages}
        onDecline={onDecline ? onDecline : closeModal}
      />
    </Form>
  );
}
